var _require$library;
var icons = require('@fortawesome/free-solid-svg-icons');
var parameters = [];
Object.keys(icons).forEach(function (keyIcon) {
  if (keyIcon.indexOf('fa') === 0) {
    parameters.push(icons[keyIcon]);
  }
});

/**
 * Add all icons used in project.
 */
(_require$library = require('@fortawesome/fontawesome-svg-core').library).add.apply(_require$library, parameters);

// /**
//  * Add all icons used in project.
//  */
// require('@fortawesome/fontawesome-svg-core').library.add(
//     icons.faUser,
//     icons.faUserPlus,
//     icons.faSignInAlt,
//     icons.faSignOutAlt,
//     icons.faTimes,
//     icons.faCogs,
//     icons.faBars,
//     icons.faHome,
//     icons.faUserCircle,
//     icons.faUserEdit,
//     icons.faUserCog,
//     icons.faUserMinus,
//     icons.faUserShield,
//     icons.faUsers,
//     icons.faUsersCog,
//     icons.faUserLock,
//     icons.faUserTag,
//     icons.faUserTie,
//     icons.faUserSecret,
//     icons.faUserNinja,
//     icons.faUserGraduate,
//     icons.faUserMd,
//     icons.faUserInjured,
//     icons.faUserAstronaut,
//     icons.faUserCheck,
//     icons.faUserTimes,
//     icons.faUserSlash,
//     icons.faUserClock,
//     icons.faUserMinus,
//     icons.faUserAlt,
//     icons.faUserAltSlash,
//     icons.faUserFriends,
//     icons.faUserPlus,
//     icons.faUserMinus,
//     icons.faUserCheck,
//     icons.faUserTimes,
//     icons.faUserCog,
//     icons.faUserEdit,
//     icons.faUserFriends,
//     icons.faUserLock,
//     icons.faUserTag,
//     icons.faUserShield,
//     icons.faUserSlash,
//     icons.faUserAstronaut,
//     icons.faUserGraduate,
//     icons.faUserClock,
//     icons.faUserMd,
//     icons.faUserInjured,
//     icons.faUserSecret,
//     icons.faUserNinja,
//     icons.faUserTie,
//     icons.faUserPlus,
//     icons.faUserMinus,
//     icons.faUserCheck,
//     icons.faUserTimes,
//     icons.faUserCog,
//     icons.faUserEdit,
//     icons.faUserFriends,
//     icons.faUserLock,
//     icons.faUserTag,
//     icons.faUserShield,
//     icons.faUserSlash,
//     icons.faUserAstronaut,
//     icons.faUserGraduate,
//     icons.faUserClock,
//     icons.faUserMd,
//     icons.faUserInjured,
//     icons.faUserSecret,
//     icons.faUserNinja,
//     icons.faUserTie,
//     icons.faUserPlus,
//     icons.faUserMinus,
//     icons.faUserCheck,
//     icons.faUserTimes,
//     icons.faUserCog,
//     icons.faUserEdit,
//     icons.faUserFriends,
//     icons.faUserLock,
//     icons.faUserTag,
//     icons.faUserShield,
//     icons.faUserSlash,
//     icons.faUserAstronaut,
//     icons.faUserGraduate,
//     icons.faUserClock,
//     icons.faUserMd,
//     icons.faUserInjured,
//     icons.faUserSecret,
//     icons.faUserNinja,
//     icons.faUserTie,
//     icons.faUserPlus,
//     icons.faUserMinus,
//     icons.faUserCheck,
//     icons.faUserTimes,
//     icons.faUserCog,
//     icons.faUserEdit,
//     icons.faUserFriends,
//     icons.faUserLock,
//     icons.faUserTag,
//     icons.faUserShield,
//     icons.faUserSlash,
//     icons.faUserAstronaut,
//     icons.faUserGraduate,
//     icons.faUserClock,
//     icons.faUserMd,
//     icons.faUserInjured,
//     icons.faUserSecret,
//     icons.faUserNinja,
//     icons.faUserTie,
//     icons.faUserPlus,
//     icons.faUserMinus,
//     icons.faUserCheck,
//     icons.faUserTimes,
//     icons.faUserCog,
//     icons.faUserEdit,
//     icons.faUserFriends,
//     icons.faUserLock,
//     icons.faUserTag,
//     icons.faUserShield,
//     icons.faUserSlash,
//     icons.faUserAstronaut,
//     icons.faUserGraduate,
//     icons.faUserClock,
//     icons.faUserMd,
//     icons.faUserInjured,
//     icons.faUserSecret,
//     icons.faUserNinja,
//     icons.faUserTie,
//     icons.faUserPlus,
//     icons.faUserMinus,
//     icons.faUserCheck,
//     icons.faUserTimes,
//     icons.faUserCog,
//     icons.faUserEdit,
//     icons.faUserFriends,
//     icons.faUserLock,
//     icons.faUserTag,
//     icons.faUserShield,
//     icons.faUserSlash
// );